import { cx } from "./cx";

type Size = "xs" | "sm" | "md" | "lg";
const dims: Record<Size, string> = {
  xs: "h-3.5 w-3.5 border-2",
  sm: "h-4 w-4 border-2",
  md: "h-6 w-6 border-2",
  lg: "h-10 w-10 border-[3px]",
};

export function Spinner({
  size = "md",
  className,
  label = "Loading…",
  ...rest
}: {
  size?: Size;
  className?: string;
  label?: string;
} & React.HTMLAttributes<HTMLSpanElement>) {
  return (
    <span
      role="status"
      aria-live="polite"
      className={cx("inline-flex items-center", className)}
      {...rest}
    >
      <span
        className={cx(
          dims[size],
          "inline-block animate-spin rounded-full border-current border-t-transparent text-current"
        )}
      />
      <span className="sr-only">{label}</span>
    </span>
  );
}
